import { Call, POST, PUT } from './API';

const PATH_ROOT = 'U011';

export type A01Output = {
  audition_title: string;
  messages: Array<{
    message_no: number;
    message: string;
    is_user: boolean;
    file1: string | null;
    file_name: string | null;
    revision: number;
    ins_dtm: string;
  }>;
};
export async function A01(
  userId: string,
  auditionId: string,
  lang: string,
  cancellation?: AbortSignal
) {
  return await POST(`${PATH_ROOT}/messages`, {
    user_id: userId,
    audition_id: auditionId,
    limit: 100,
    lang: lang,
    signal: cancellation,
  });
}

export async function A02(userId: string, auditionId: string) {
  return await PUT(`${PATH_ROOT}/messages`, {
    user_id: userId,
    audition_id: auditionId,
  });
}

export async function A03(
  userId: string,
  auditionId: string,
  message: string,
  file_name?: string,
  original_file_name?: string,
  cancellation?: AbortSignal
) {
  return await POST(`${PATH_ROOT}/message`, {
    user_id: userId,
    audition_id: auditionId,
    message: message,
    file_name: file_name ?? '',
    original_file_name: original_file_name ?? '',
    signal: cancellation,
  });
}

export async function A04(
  userId: string,
  auditionId: string,
  filePath: string,
  cancellation?: AbortSignal
) {
  return await POST(`${PATH_ROOT}/attached_file`, {
    user_id: userId,
    audition_id: auditionId,
    file_path: filePath,
    signal: cancellation,
  });
}
